import React from 'react';

function Explain({ withImage, timeLimit }) {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className={`bg-white border border-gray-300 p-4 ${withImage ? 'w-full' : 'max-w-3xl'} w-full`} >
        <h1 className="text-2xl text-gray-800 text-center font-bold m-2">
          Story
        </h1>
        <div className="flex justify-center">
          <p className="w-full text-center">
            In this experiment, your task is to read the story.
            Try to remember the story as much as you can.
            After reading, you will see ten multiple-choice questions.
            Please choose the answer which is most likely correct.
            The time limit for reading is {timeLimit * 60} seconds.
            Please scroll down and click start button whenever you are ready.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Explain;
